export class IndustryCategory {
    constructor(
        public categoryId: number,
        public industryCode?: string
    ) { }
}
